import { useState } from "react";
import { appConfig } from "../constants/config/appConfig";

// Custom hook for managing a token stored in the local storage
const useLocalStorage = (key) => {
  // State variable to store the token value
  const [userSession, setUserSessionInternal] = useState(() => {
    // Retrieve the token from the local storage
    const tempUserDetails = localStorage.getItem(key);
    // Decode the token using the decode function

    return tempUserDetails ? JSON.parse(tempUserDetails) : null;
  });

  /* function definition to set the user session */
  const setUserSession = ({
    userName,
    userEmail,
    userRole,
    userProfileImage,
    userId,
    userPermissions,
  }) => {
    const userNameKey = appConfig.SESSION_USER_NAME;
    const userEmailKey = appConfig.SESSION_USER_EMAIL;
    const userRoleKey = appConfig.SESSION_USER_ROLE;
    const userProfileImageKey = appConfig.SESSION_USER_PROFILE_IMAGE;
    const userIdKey = appConfig.SESSION_USER_ID;
    const userPermissionsKey = appConfig.SESSION_USER_PERMISSIONS;

    const userObj = {
      [userNameKey]: userName,
      [userEmailKey]: userEmail,
      [userRoleKey]: userRole,
      [userProfileImageKey]: userProfileImage,
      [userIdKey]: userId,
      [userPermissionsKey]: userPermissions,
    };
    localStorage.setItem(appConfig.SESSION_USER_INFO, JSON.stringify(userObj));

    setUserSessionInternal({
      userName,
      userEmail,
      userRole,
      userProfileImage,
      userId,
      userPermissions,
    });
  };
  /* function definition to set the user session */

  /* function definition to remove the user session */
  const removeUserSession = () => {
    localStorage.clear();
  };
  /* function definition to remove the user session */

  return { userSession, setUserSession, removeUserSession };
};

export default useLocalStorage;
